<button
  class="icon-btn cursor-pointer"
  type="button"
  zHoveredLeftMenu
  [menuOptions]="menuOptions"
  [hoverMenuTemplate]="toolsMenu"
>
  <em class="ph ph-circles-four"></em>
</button>

<ng-template #toolsMenu>
  <div class="w-full tools-menu flex flex-column">
    <div class="menu-header">
      <div class="body-large-bold">Tools</div>
    </div>
    <div class="flex flex-column gap-1 tools-menu-list flex-1">
      @for (tool of tools(); track $index) {
        <a
          class="flex align-items-center gap-2 tools-menu-list-item"
          (click)="openTool(tool.publicUrl)"
        >
          <em class="ph ph-cursor icon-primary-color text-xl"></em>
          <div
            class="label-large-bold webkit-box-one-line"
            [title]="tool.name"
          >
            {{ tool.name }}
          </div>
          <em class="ph ph-arrow-square-out ml-auto"></em>
        </a>
      } @empty {
        <div class="rotate-loading">
          <img
            src="assets/google-map-assets/icons/CircleNotch.svg"
            alt=""
          />
        </div>
      }
    </div>
  </div>
</ng-template>
